import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import JsonFormatter from '../views/JsonFormatter.vue'
import Timestamp from '../views/Timestamp.vue'
import WordCount from '../views/WordCount.vue'
import Calculator from '../views/Calculator.vue'
import Markdown from '../views/Markdown.vue'
import ImageTool from '../views/ImageTool.vue'
import Mortgage from '../views/Mortgage.vue'
import Tax from '../views/Tax.vue'
import BMI from '../views/BMI.vue'
import Exchange from '../views/Exchange.vue'
import Traditional from '../views/Traditional.vue'
import Uppercase from '../views/Uppercase.vue'
import TextDedup from '../views/TextDedup.vue'
import TextReplace from '../views/TextReplace.vue'
import TextSort from '../views/TextSort.vue'
import TextNumber from '../views/TextNumber.vue'
import Text2Html from '../views/Text2Html.vue'
import WordFrequency from '../views/WordFrequency.vue'
import NamingConverter from '../views/NamingConverter.vue'
import RegexTester from '../views/RegexTester.vue'
import ColorConverter from '../views/ColorConverter.vue'
import CodeFormatter from '../views/CodeFormatter.vue'
import CrontabParser from '../views/CrontabParser.vue'
import QrGenerator from '../views/QrGenerator.vue'
import QrScanner from '../views/QrScanner.vue'
import TaxRate from '../views/TaxRate.vue'
import ListSum from '../views/ListSum.vue'
import LoanCalc from '../views/LoanCalc.vue'
import Base64 from '../views/Base64.vue'
import UrlCodec from '../views/UrlCodec.vue'
import HashTool from '../views/HashTool.vue'
import UnicodeConverter from '../views/UnicodeConverter.vue'
import MorseCode from '../views/MorseCode.vue'
import PasswordGenerator from '../views/PasswordGenerator.vue'
import UuidGenerator from '../views/UuidGenerator.vue'
import Privacy from '../views/Privacy.vue'
import About from '../views/About.vue'
import Blog from '../views/Blog.vue'
import BlogArticle from '../views/BlogArticle.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: '月升工具网 - 超实用查询工具' }
  },
  {
    path: '/json',
    name: 'JsonFormatter',
    component: JsonFormatter,
    meta: { title: 'JSON格式化工具 - 月升工具网' }
  },
  {
    path: '/timestamp',
    name: 'Timestamp',
    component: Timestamp,
    meta: { title: '时间戳转换 - 月升工具网' }
  },
  {
    path: '/wordcount',
    name: 'WordCount',
    component: WordCount,
    meta: { title: '字数统计 - 月升工具网' }
  },
  {
    path: '/calculator',
    name: 'Calculator',
    component: Calculator,
    meta: { title: '计算器 - 月升工具网' }
  },
  {
    path: '/markdown',
    name: 'Markdown',
    component: Markdown,
    meta: { title: 'Markdown编辑器 - 月升工具网' }
  },
  {
    path: '/image',
    name: 'ImageTool',
    component: ImageTool,
    meta: { title: '图片处理 - 月升工具网' }
  },
  {
    path: '/mortgage',
    name: 'Mortgage',
    component: Mortgage,
    meta: { title: '房贷计算器 - 月升工具网' }
  },
  {
    path: '/tax',
    name: 'Tax',
    component: Tax,
    meta: { title: '个税计算器 - 月升工具网' }
  },
  {
    path: '/bmi',
    name: 'BMI',
    component: BMI,
    meta: { title: 'BMI计算器 - 月升工具网' }
  },
  {
    path: '/exchange',
    name: 'Exchange',
    component: Exchange,
    meta: { title: '汇率计算 - 月升工具网' }
  },
  {
    path: '/traditional',
    name: 'Traditional',
    component: Traditional,
    meta: { title: '繁体字转换 - 月升工具网' }
  },
  {
    path: '/uppercase',
    name: 'Uppercase',
    component: Uppercase,
    meta: { title: '大写金额转换 - 月升工具网' }
  },
  {
    path: '/text-dedup',
    name: 'TextDedup',
    component: TextDedup,
    meta: { title: '文本去重工具 - 月升工具网' }
  },
  {
    path: '/text-replace',
    name: 'TextReplace',
    component: TextReplace,
    meta: { title: '文本替换工具 - 月升工具网' }
  },
  {
    path: '/text-sort',
    name: 'TextSort',
    component: TextSort,
    meta: { title: '文本排序工具 - 月升工具网' }
  },
  {
    path: '/text-number',
    name: 'TextNumber',
    component: TextNumber,
    meta: { title: '文本添加序号 - 月升工具网' }
  },
  {
    path: '/text-to-html',
    name: 'Text2Html',
    component: Text2Html,
    meta: { title: '文本转HTML - 月升工具网' }
  },
  {
    path: '/word-frequency',
    name: 'WordFrequency',
    component: WordFrequency,
    meta: { title: '词频统计工具 - 月升工具网' }
  },
  {
    path: '/naming-converter',
    name: 'NamingConverter',
    component: NamingConverter,
    meta: { title: '命名转换器 - 月升工具网' }
  },
  {
    path: '/regex',
    name: 'RegexTester',
    component: RegexTester,
    meta: { title: '正则表达式测试 - 月升工具网' }
  },
  {
    path: '/color-converter',
    name: 'ColorConverter',
    component: ColorConverter,
    meta: { title: '颜色值转换 - 月升工具网' }
  },
  {
    path: '/code-formatter',
    name: 'CodeFormatter',
    component: CodeFormatter,
    meta: { title: '代码格式化工具 - 月升工具网' }
  },
  {
    path: '/crontab',
    name: 'CrontabParser',
    component: CrontabParser,
    meta: { title: 'Crontab时间计算 - 月升工具网' }
  },
  {
    path: '/qr-generator',
    name: 'QrGenerator',
    component: QrGenerator,
    meta: { title: '二维码生成器 - 月升工具网' }
  },
  {
    path: '/qr-scanner',
    name: 'QrScanner',
    component: QrScanner,
    meta: { title: '二维码解析器 - 月升工具网' }
  },
  {
    path: '/tax-rate',
    name: 'TaxRate',
    component: TaxRate,
    meta: { title: '税金税率计算器 - 月升工具网' }
  },
  {
    path: '/list-sum',
    name: 'ListSum',
    component: ListSum,
    meta: { title: '列表求和计算器 - 月升工具网' }
  },
  {
    path: '/loan-calc',
    name: 'LoanCalc',
    component: LoanCalc,
    meta: { title: '贷款计算器 - 月升工具网' }
  },
  {
    path: '/base64',
    name: 'Base64',
    component: Base64,
    meta: { title: 'Base64编解码 - 月升工具网' }
  },
  {
    path: '/url-codec',
    name: 'UrlCodec',
    component: UrlCodec,
    meta: { title: 'URL编解码 - 月升工具网' }
  },
  {
    path: '/hash',
    name: 'HashTool',
    component: HashTool,
    meta: { title: 'MD5/SHA哈希 - 月升工具网' }
  },
  {
    path: '/unicode',
    name: 'UnicodeConverter',
    component: UnicodeConverter,
    meta: { title: 'Unicode编码转换 - 月升工具网' }
  },
  {
    path: '/morse',
    name: 'MorseCode',
    component: MorseCode,
    meta: { title: '摩斯电码转换 - 月升工具网' }
  },
  {
    path: '/password-gen',
    name: 'PasswordGenerator',
    component: PasswordGenerator,
    meta: { title: '随机密码生成器 - 月升工具网' }
  },
  {
    path: '/uuid',
    name: 'UuidGenerator',
    component: UuidGenerator,
    meta: { title: 'UUID/GUID生成器 - 月升工具网' }
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: Privacy,
    meta: { title: '隐私政策 - 月升工具网' }
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: { title: '关于我们 - 月升工具网' }
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog,
    meta: { title: '技术博客 - 月升工具网' }
  },
  {
    path: '/blog/:id',
    name: 'BlogArticle',
    component: BlogArticle,
    meta: { title: '技术博客 - 月升工具网' }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 如果是浏览器后退/前进，恢复之前的滚动位置
    if (savedPosition) {
      return savedPosition
    }
    // 否则滚动到页面顶部
    return { top: 0 }
  }
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '月升工具网'
  next()
})

export default router
